import React from 'react';
import { useSelector } from 'react-redux';
import styles from '../styles/form.scss';
const NoWebRTC = () => {
    const logoSrc = useSelector((state) => state.branding.partnerLogoSrc || '');
    return (React.createElement("div", { className: styles.background },
        React.createElement("div", { className: styles.container },
            React.createElement("img", { alt: 'Logo', className: styles.logo, src: logoSrc }),
            React.createElement("div", { className: styles.form },
                React.createElement("div", { className: styles.form_content },
                    React.createElement("h2", { className: styles.title_smaller }, "Your browser does not support WebRTC"),
                    React.createElement("div", { className: styles.form_body },
                        "You can find out more about which browsers do support WebRTC",
                        ' ',
                        React.createElement("a", { href: 'http://caniuse.com/#feat=rtcpeerconnection', target: '_blank', className: styles.link, rel: 'noreferrer' }, "here"),
                        "."))))));
};
export default NoWebRTC;
